import type { Jast } from '@atlaskit/jql-ast';
import { substring } from './common';

export const getOrderBy = (jast: Jast): string | undefined => {
	const jqlString = jast.represents;
	const orderBy = jast.query?.orderBy;

	if (orderBy && orderBy.position) {
		return substring(jqlString, orderBy.position[0], orderBy.position[1]);
	}

	return undefined;
};
